import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  Switch,
  Grid,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import { companySettingsApi, DepartmentApis } from "../../../Data/axios";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import OutlinedInput from "@mui/material/OutlinedInput";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const AttendanceSettingsTab = () => {
  const [leadSource, setLeadSource] = useState([]);
  const [leadDepartment, setLeadDepartment] = useState([]);
  const [sendReminders, setSendReminders] = useState(false);
  const [shiftChange, setShiftChange] = useState(true);
  const [clockInLoc, setClockInLoc] = useState(false);
  const [clockInOut, setClockInOut] = useState(true);
  const [defaultLocation, setDefaultLocation] = useState("Office");
  const [radius, setRadius] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const [clockInOutside, setClockInOutside] = useState(false);
  const [ipAddresses, setIpAddresses] = useState([]);
  const [monthlyReport, setMonthlyReport] = useState("");
  const [weekStart, setWeekStart] = useState("Monday");
  const [attRemainder, setAttRemainder] = useState("");

  const handleAddIpAddress = () => {
    setIpAddresses([...ipAddresses]);
  };
  const [isAutoClockInEnabled, setIsAutoClockInEnabled] = useState(false);
  const [isAutoClockLocation, setIsAutoClockLocation] = useState(false);
  const [isAutoClockCheck, setIsAutoClockCheck] = useState(false);
  const [isAutoClockAttend, setIsAutoClockAttend] = useState(false);
  const [personName, setPersonName] = React.useState([]);
  const weekendDays = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 7 },
  ];
  const handleIpChange = (index, value) => {
    const updatedIps = [...ipAddresses];
    updatedIps[index] = value;
    setIpAddresses(updatedIps);
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    setShiftChange(leadSource.shift_change_request === 1 ? true : false);
    setClockInLoc(leadSource.save_clock_in_location === 1 ? true : false);
    setClockInOut(leadSource.self_clock_in_out === 1 ? true : false);
    setIsAutoClockInEnabled(leadSource.auto_clock_in === 1 ? true : false);
    setClockInOutside(
      leadSource.clock_in_outside_shift_hrs === 1 ? true : false
    );

    setRadius(leadSource.clock_in_location_radius);
    setDefaultLocation(leadSource.defualt_location);
    setIpAddresses(leadSource.clock_in_ip);
    setMonthlyReport(leadSource.monthly_report);
    setWeekStart(leadSource.week_starts);
    setAttRemainder(leadSource.attendance_reminder);
  }, [leadSource]);
  async function getData() {
    const response = await companySettingsApi.attendanceGetAll();
    setLeadSource(response);
  }
  useEffect(() => {
    getDepartment();
  }, []);
  const personalName = personName.map((item) => item.toString());

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  async function getDepartment() {
    const response = await DepartmentApis.getDepartmentName();
    console.log(response, "all response got");
    setLeadDepartment(response);
  }
  const handleSaveBtn = async () => {
    const item = {
      shift_change_request: shiftChange === true ? "1" : "0",
      save_clock_in_location: clockInLoc === true ? "1" : "0",
      self_clock_in_out: clockInOut === true ? "1" : "0",
      auto_clock_in: isAutoClockInEnabled === true ? "1" : "0",
      defualt_location: defaultLocation,
      clock_in_location_radius: radius,
      clock_in_outside_shift_hrs: clockInOutside === true ? "1" : "0",
      clock_in_ip: ["123:12:1", "123:12:1"],
      monthly_report: personalName,
      week_starts: weekStart,
      attendance_reminder: attRemainder,
    };

    try {
      console.log(item, "all item got");
      const formData = new FormData();
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await companySettingsApi.attendanceUpdate(formData);
      showAlert(" Updated Successfully!", "success");
      getData();
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add ", "error");
    }
  };
  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <Grid
        container
        spacing={3}
        sx={{
          bgcolor: "#fff",
          color: "#000",
        }}
      >
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={shiftChange}
                  onChange={(e) => setShiftChange(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Allow employee to request shift change"
              sx={{ width: "100%" }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={clockInLoc}
                  onChange={(e) => setClockInLoc(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Save Clock-In Location"
              sx={{ width: "100%" }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={clockInOut}
                  onChange={(e) => setClockInOut(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Allow Employee self Clock-in/Clock-Out"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAutoClockInEnabled}
                  onChange={(e) => setIsAutoClockInEnabled(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Auto clock-in employee by first sign in"
            />
          </FormGroup>
        </Grid>

        {isAutoClockInEnabled && (
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Default Location
              </Typography>
              <Select
                value={defaultLocation}
                onChange={(e) => setDefaultLocation(e.target.value)}
                sx={{
                  border: "1px solid black",
                  boxSizing: "border-box",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "black !important",
                    "&:hover fieldset": {
                      borderColor: "black !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "black !important",
                    },
                  },
                  color: "black",
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <span style={{ color: "gray" }}>Select location</span>
                    );
                  }
                  return selected === 1 ? "Office" : "Home";
                }}
              >
                <MenuItem value={1}>Office</MenuItem>
                <MenuItem value={2}>Home</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAutoClockLocation}
                  onChange={(e) => setIsAutoClockLocation(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Clock-in check with added location Radius"
            />
          </FormGroup>
          {isAutoClockLocation && (
            <Box>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Radius (in meter)
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <TextField
                    required
                    variant="outlined"
                    fullWidth
                    placeholder="distance in meter"
                    type="email"
                    inputProps={{
                      style: {
                        color: "black",
                        border: "1px solid black",
                        borderRadius: "5px",
                      },
                    }}
                    value={radius}
                    InputLabelProps={{ style: { color: "black" } }}
                    onChange={(e) => setRadius(e.target.value)}
                    sx={{
                      height: "42px",
                      marginTop: "5px",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black",
                        "&:hover fieldset": {
                          borderColor: "black",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        "&::placeholder": { color: "gray" },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>

        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={clockInOutside}
                  onChange={(e) => setClockInOutside(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Allow clock-in outside shift hours"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAutoClockCheck}
                  onChange={(e) => setIsAutoClockCheck(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Clock-in check with added IP address"
            />
          </FormGroup>
        </Grid>
        {isAutoClockCheck &&
          ipAddresses.map((ip, index) => (
            <Grid item xs={12}>
              <TextField
                required
                variant="outlined"
                fullWidth
                placeholder="IP Address"
                type="text"
                inputProps={{
                  style: {
                    color: "black",
                    border: "1px solid black",
                    borderRadius: "5px",
                  },
                }}
                // value={ip}
                InputLabelProps={{ style: { color: "black" } }}
                onChange={(e) => handleIpChange(index, e.target.value)}
                sx={{
                  marginTop: "5px",
                  height: "42px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "black",
                    "&:hover fieldset": {
                      borderColor: "black",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "black",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    "&::placeholder": { color: "gray" },
                  },
                }}
              />
            </Grid>
          ))}
        {isAutoClockCheck && (
          <Grid item xs={12}>
            <Button
              variant="outlined"
              onClick={handleAddIpAddress}
              sx={{
                color: "#1d82f5",
                "&:hover": {
                  color: "#000",
                },
              }}
            >
              Add IP Address
            </Button>
          </Grid>
        )}

        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAutoClockAttend}
                  onChange={(e) => setIsAutoClockAttend(e.target.checked)}
                  sx={{
                    color: "#333",
                    "&.Mui-checked": {
                      color: "#1d82f5",
                    },
                  }}
                />
              }
              label="Send monthly attendance report email"
            />
          </FormGroup>
          {isAutoClockAttend && (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Choose roles for email report
              </Typography>
              {/* <Select
                value={monthlyReport}
                autoFocus
                onChange={(e) => setMonthlyReport(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  border: "1px solid black",
                  // height: "40px",
                  boxSizing: "border-box",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "black !important",
                    "&:hover fieldset": {
                      borderColor: "black !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "black !important",
                    },
                  },
                  color: "black",
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <span style={{ color: "gray" }}>Nothing Selected</span>
                    );
                  }
                  return selected;
                }}
              >
                {businessLocation.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select> */}
              <FormControl>
                <Select
                  multiple
                  displayEmpty
                  value={personName || []} // Default to an empty array
                  onChange={handleChange}
                  input={<OutlinedInput />}
                  sx={{
                    borderRadius: "4px",
                    border: ".5px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return "Select Agent Group";
                    }

                    // Map selected IDs to their department names
                    const selectedDepartments = leadDepartment
                      .filter((department) => selected.includes(department.id))
                      .map((department) => department.department);

                    return selectedDepartments.join(", ");
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ "aria-label": "Select Agent Group" }}
                >
                  {leadDepartment.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                      // style={getStyles(item.department, personName, theme)} // Use item.department if specific styling is needed
                    >
                      {item.department}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </Grid>

        <Grid item xs={12}>
          <Stack direction="column">
            <Typography variant="p" gutterBottom style={{ color: "black" }}>
              Week Starts From
            </Typography>
            <Select
              value={weekStart || 1} // Default to "Monday"
              onChange={(e) => setWeekStart(e.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Select Week Start" }}
              sx={{
                border: "1px solid black",
                boxSizing: "border-box",
                "& .MuiOutlinedInput-root": {
                  borderColor: "black !important",
                  "&:hover fieldset": {
                    borderColor: "black !important",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "black !important",
                  },
                },
                color: "black",
              }}
              renderValue={(selected) => {
                const selectedDay = weekendDays.find(
                  (day) => day.value === selected
                );
                if (!selectedDay) {
                  return <span style={{ color: "gray" }}>Monday</span>;
                }
                return selectedDay.label;
              }}
            >
              {weekendDays.map((item) => (
                <MenuItem value={item.value} key={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={sendReminders}
                onChange={(e) => setSendReminders(e.target.checked)}
                sx={{
                  margin: "10px 20px",
                  "& .MuiSwitch-switchBase": {
                    color: "gray", // Default color for the knob
                  },
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#1d82f5", // Knob color when checked
                  },
                  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                    backgroundColor: "gray", // Track color when unchecked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1d82f5", // Track color when checked
                  },
                }}
              />
            }
            label="Attendance Reminder Status"
          />
          {sendReminders && (
            <Box>
              <p style={{ fontSize: "1rem" }}>Reminder After Minutes *</p>
              <input
                type="text"
                name="days"
                id="day"
                value={attRemainder}
                onChange={(e) => setAttRemainder(e.target.value)}
                style={{
                  width: "50%",
                  border: "1px solid gray",
                  padding: "8px",
                  height: "40px",
                  borderRadius: "2px",
                }}
              />
              <span
                style={{
                  border: "1px solid gray",
                  padding: "10px",
                  paddingBottom: "11px",
                  // height: "42px",
                  paddingTop: "12px",
                }}
              >
                Days
              </span>
            </Box>
          )}
        </Grid>

        <Grid item xs={12}>
          <Button
            sx={{
              backgroundColor: "#1d82f5",
              "&:hover": {
                backgroundColor: "orange",
              },
              color: "white",
              margin: "10px 20px 30px 20px",
              height: "35px",
              width: "60px",
            }}
            onClick={handleSaveBtn}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AttendanceSettingsTab;
